var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgvectorTrustedby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 893,
    viewBox: "0 0 1440 893",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-194.22 55.1029L-280.06 114.102C-356.829 166.866 -384.351 267.304 -345.204 351.832C-307.621 432.984 -218.77 477.203 -131.368 458.254L119.859 403.787C203.209 385.717 290.285 398.522 364.903 439.824L1103.38 848.57C1174.76 888.082 1257.66 901.568 1337.89 886.723L1434.01 868.937C1475.12 861.329 1511.23 836.986 1533.7 801.726C1612.73 677.704 1485.55 525.499 1349.46 581.238L1239.45 626.292C1186.16 648.119 1125.82 644.184 1075.15 616.828C779.559 457.269 533.145 356.41 355.628 172.329C211.614 22.9891 -23.2441 -62.4109 -194.22 55.1029Z",
    fill: "#2C2A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgvectorTrustedby);
export default __webpack_public_path__ + "static/media/bgvectorTrustedby.f53bf58308fa0b00bb6beadcc8360b37.svg";
export { ForwardRef as ReactComponent };